import { Resource } from "@app/resources";

interface CodeMapSetModel {
  codeMapSetId: number;
  codeMapSetVersions: CodeMapSetVersionModel[];
  codeMapType: CodeMapTypeEnum;
  resource: Resource;
  fallbackCodeMapSetId?: number;
}

interface CodeMapSetModelWithActiveProjects {
  codeMapSetId: number;
  codeMapSetVersions: CodeMapSetVersionModel[];
  codeMapType: CodeMapTypeEnum;
  resource: Resource;
  fallbackCodeMapSetId?: number;
  activeProjectsCount: number;
}

interface CodeMapItem {
  sourceValue: string;
  codeMapValue: string;
}

interface AddCodeMaps {
  codeMapItems: CodeMapItem[]
}

interface CodeMapSetVersionModel {
  codeMapSetVersionId: number;
  codeMapSetId: number;
  codeMapSetVersionStatus: string;
  dateCreated: string;
  dateLastUpdated: string;
  dateActivated: string;
  dateArchived: string;
  datePurged: string;
}

enum CodeMapTypeEnum {
  Unknown = "Unknown",
  CountyClassMap = "CountyClassMap",
  ZipCodeClassMap = "ZipCodeClassMap",
  SpecialtyCodeMap = "SpecialtyCodeMap",
  SpecialtyToBdxCodeMap = "SpecialtyToBdxCodeMap",
  SpecialtyToQDPCodeMap = "SpecialtyToQdpCodeMap",
  MotiveDomainToSpecialtyCodeMap = "MotiveDomainToSpecialtyCodeMap",
  SpecialtyMileageExpansionCrosswalk = "SpecialtyMileageExpansionCrosswalk",
  RegionalCodeMap = "RegionalCodeMap",
}

export {
  CodeMapSetModel,
  CodeMapSetModelWithActiveProjects,
  CodeMapSetVersionModel,
  CodeMapTypeEnum,
  CodeMapItem,
  AddCodeMaps
};
